import { JobGroupJobfeedAutoSuggest } from 'app/employer/components/autoSuggest';
import withInputErrorMessage from '../withInputErrorMessage';
import withAutoSuggestFormik from './withAutoSuggestFormik';

export default withAutoSuggestFormik(withInputErrorMessage(JobGroupJobfeedAutoSuggest));
